import { createSelector } from 'reselect';

import {
  getItemById,
  getDataFromStateAndProps,
} from './common';

import { getUsers } from './users';


export const getCommentsWithCreator = createSelector(
  [getDataFromStateAndProps('comments'), getUsers],
  (comments, users) =>
    Object.keys(comments).map(key => Object.assign({}, {
      ...comments[key],
      createdBy: users[comments[key].createdBy] || null,
    })),
);

export const getCommentById = createSelector(
  [getItemById('comments', 'commentId')],
  comment => comment || {},
);



// WEBPACK FOOTER //
// ./src/redux/selectors/comments.js